import React, { useEffect, useState } from 'react';
import Layout from './layout';
import {
  getStudents,
  createStudent,
  updateStudent,
  deleteStudent,
} from './api/studentApi';

function StudentsPage() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ email: '', full_name: '', phone: '' });
  const [editId, setEditId] = useState(null);

  const fetchStudents = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getStudents();
      setStudents(data.students || data); // support both array and {students: []}
    } catch (err) {
      setError('Failed to fetch students');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    setFormData({ email: '', full_name: '', phone: '' });
    setEditId(null);
    setShowForm(true);
  };

  const handleEdit = (student) => {
    setFormData({
      email: student.User?.email || student.email || '',
      full_name: student.User?.full_name || student.full_name || '',
      phone: student.User?.phone || student.phone || '',
    });
    setEditId(student.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this student?')) return;
    try {
      await deleteStudent(id);
      fetchStudents();
    } catch {
      setError('Failed to delete student');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await updateStudent(editId, formData);
      } else {
        await createStudent(formData);
      }
      setShowForm(false);
      fetchStudents();
    } catch {
      setError('Failed to save student');
    }
  };

  return (
    <Layout>
      <div className="container p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Students</h2>
          <button className="btn btn-primary" onClick={handleAdd}>Add Student</button>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (<>
          <a href="/">Click here to assign student to a course</a>
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {students.length === 0 && (
                <tr><td colSpan={4} className="text-center">No students found.</td></tr>
              )}
              {students.map((student) => {
                const name = student.User?.full_name || student.full_name;
                const email = student.User?.email || student.email;
                const phone = student.User?.phone || student.phone;
                // Australian phone formatting
                let formattedPhone = phone;
                if (typeof phone === 'string') {
                  const digits = phone.replace(/\D/g, '');
                  if (digits.length === 10) {
                    if (["02","03","07","08"].includes(digits.slice(0,2))) {
                      // Mobile: XX XXXX XXXX
                      formattedPhone = `${digits.slice(0,2)}-${digits.slice(2,6)}-${digits.slice(6,10)}`;
                    } else if (digits.startsWith('04') || digits.startsWith('05')) {
                      // Landline: XXXX-XXX-XXX
                      formattedPhone = `${digits.slice(0,4)}-${digits.slice(4,7)}-${digits.slice(7,10)}`;
                    }
                  }
                }
                return (
                  <tr key={student.id}>
                    <td>{name}</td>
                    <td>{email ? <a href={`mailto:${email}`}>{email}</a> : ''}</td>
                    <td>{formattedPhone}</td>
                    <td>
                      <button className="btn btn-sm btn-secondary me-2" onClick={() => handleEdit(student)}>Edit</button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(student.id)}>Delete</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table></>
        )}

        {/* Modal/Form for Add/Edit */}
        {showForm && (
          <div className="modal show d-block" tabIndex="-1" role="dialog" style={{background: 'rgba(0,0,0,0.3)'}}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form onSubmit={handleFormSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">{editId ? 'Edit Student' : 'Add Student'}</h5>
                    <button type="button" className="btn-close" onClick={() => setShowForm(false)} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input type="text" className="form-control" name="full_name" value={formData.full_name} onChange={handleInputChange} required />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} required />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone</label>
                      <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleInputChange} required />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default StudentsPage; 